export { initAnalytics } from './utils/initAnalytics';
export { default as clearAnalytics } from './utils/clearAnalytics';
export { default as trackEvent } from './Events';
export * from './Identify';
export * from './Pages';